/**
 * footer
 */

// Module dependencies
import 'protons';

// Module template
import './_footer.twig';

// Module styles
import './_footer.scss';
import './ada.png';
import './eho.png';
import './drop-shadow.png';

export const name = 'footer';

export function disable() {}

export function enable() {}

export default enable;
